import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import SBProTopNav from '@structural/top-nav.vue';
import SBProPageHeader from '@structural/page-header.vue';
import SBProLayoutDefault from '@structural/layout-default.vue';
import SBProPageSection from '@structural/page-section.vue';
let RealEstate = class RealEstate extends Vue {
};
RealEstate = __decorate([
    Component({
        components: {
            'sbpro-top-nav': SBProTopNav,
            'sbpro-page-header': SBProPageHeader,
            'sbpro-layout-default': SBProLayoutDefault,
            'sbpro-page-section': SBProPageSection,
        },
    })
], RealEstate);
export default RealEstate;
